// @ts-nocheck

import React, { useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaCirclePlus, FaCircleMinus } from "react-icons/fa6";
import { createLanguage } from "../../../features/language";
import Select from "react-select";
import { isoLanguages } from "../../../assets/language";
import DashboardNavbar from "../../../components/navbars/dashboardNavbar";

const AddLanguage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    folder_name: "language", // Language folder name
    language_code: "", // Language code (ar, en, etc.)
    language: "", // Full language name (Arabic, English, etc.)
    contant: null, // Content (Excel file)
  });

  const [imagePreview, setImagePreview] = useState(null); // For image preview

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value, // Handle checkboxes
    }));
  };

  const handleSelectChange = (selectedOption: any) => {
    console.log(selectedOption,'selectedOption');
    
    setFormData((prev) => ({
      ...prev,
      ['language_code']: selectedOption?.value || "",
      ['language']: selectedOption?.label || "",

    }));
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormData((prev) => ({
        ...prev,
        contant: e.target.files[0], // Handle Excel file change
      }));
    }
  };

  const handleSubmit = () => {
    const formDataFinal = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formDataFinal.append(key, value);
      }
    });

    dispatch(createLanguage(formDataFinal))
      .then((res) => {
        console.log(res.payload.message,'res');
        
        toast.success(res.payload.message);
        navigate("/languages"); 
      })
      .catch((err) => {
        console.log(err, "error");
        toast.error("An error occurred while adding the language.");
      });
  };

  return (
    <SoftBox

      className="language-box"
    >
                  <DashboardNavbar />
      
      <SoftBox >
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
            Add Language
          </SoftTypography>
        </SoftBox>

        <SoftBox component="form" role="form">
          {/* <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Language Code
              </SoftTypography>
            </SoftBox>
            <Select
              name="language_code"
              options={isoLanguages.map(lang => ({ value: lang.code, label: lang.name }))}
              onChange={(selectedOption) => handleSelectChange(selectedOption, "language_code")}
              placeholder="Select Language Code"
            />
          </SoftBox> */}

          <SoftBox mb={1}>
            <SoftBox  ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="medium">
                Language
              </SoftTypography>
            </SoftBox>
            <Select
              name="language"
              options={isoLanguages.map(lang => ({ value: lang.code, label: lang.name }))}
              onChange={(selectedOption) => handleSelectChange(selectedOption)}
              placeholder="Select Language"
            />
          </SoftBox>

          <SoftBox mb={2}>
            <SoftBox  >
              <SoftTypography component="label" variant="caption" fontWeight="medium">
                Content (Excel File)
              </SoftTypography>
            </SoftBox>
            <input
              type="file"
              accept=".xls,.xlsx"
              name="contant"
              onChange={handleFileChange}
              className="file-type-input"
            />
          </SoftBox>

          <SoftBox mt={4} mb={1}>
            <SoftButton variant="gradient" color="final" fullWidth onClick={handleSubmit}>
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default AddLanguage;
